import "./css/board_view.css";
import React, { useRef, useEffect, useState } from "react";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import downarrow from "./img/icon/arrow_down.png";
import uparrow from "./img/icon/arrow_up.png";
import dompurify from "dompurify";
import { useTranslation } from "react-i18next";
import i18next from "../config/lang/i18next";
import styled from "styled-components";
import Cookies from "universal-cookie";
import SubHeader from "../components/subHeader3";
import SubHeader2 from "../components/subHeader4";

const cookies = new Cookies();

const View = () => {
  const [korean, setKor] = useState("false");
  const { t, i18n } = useTranslation();
  const [boardLink, setBoardLink] = useState("");
  const sanitizer = dompurify.sanitize;
  const language = useRef(null);
  const { board } = useParams();
  const [header, setHeader] = useState("");
  const [isloggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    setBoardLink("/" + board);
    if (board === "pr") {
      setHeader("홍보자료");
    } else if (board === "news") {
      setHeader("활동사항");
    } else {
      setHeader("인재채용");
    }
    const post = {
      no: no,
      board_name: board,
    };
    fetch("https://thegmmedical.com:5002/check", {
      method: "get", // 통신방법
      headers: {
        "content-type": "application/json",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.message === "user존재") {
          setLoggedIn(true);
        }
      })
      .catch(() => {});
    fetch("https://thegmmedical.com:5002/api/getpost", {
      method: "post", // 통신방법
      headers: {
        "content-type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(post),
    })
      .then((res) => res.json())
      .then((json) => {
        setData(json[0]);
        console.log(json[0]);
      });

    language.current = sessionStorage.getItem("language");
    if (language === null) {
      language.current = cookies.get("language");
    }
    i18next.changeLanguage(language.current);
    if (language.current === "kr-KR") {
      setKor(true);
    } else {
      setKor(false);
    }
  }, []);
  const [data, setData] = useState({});
  //const [token, setToken] = useState(cookies.get("access-token"));
  const { no } = useParams();
  const [prev, setPrev] = useState("");
  const [next, setNext] = useState("");
  const navigate = useNavigate();
  //const [ isloggedIn, setIsLogin ] = useState(false);
  const board_id = data.board_id;

  function updateBoard() {
    navigate("/" + board + "/update/" + board_id, {
      state: {
        board_id: board_id,
        content: data.content,
        subject: data.subject,
        imgLink: data.image_link,
      },
    });
  }

  function deleteBoard() {
    const post = {
      board_id: board_id,
      board_name: board,
    };
    if (
      window.confirm(
        "해당 게시물을 삭제하시겠습니까? 삭제된 데이터는 복구할 수 없습니다."
      )
    ) {
      fetch("https://thegmmedical.com:5002/api/boarddelete", {
        method: "post", // 통신방법
        headers: {
          "content-type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(post),
      })
        .then((res) => res.json())
        .then((json) => {
          setData(json[0]);
          console.log(data);
          alert("게시물이 삭제되었습니다.");
          navigate("/" + board);
        });
    } else {
    }
  }

  if (data === null) {
    return <>Still loading...</>;
  }

  return (
    <div className="wrapper">
      {header === "인재채용" && <SubHeader2 />}
      {header !== "인재채용" && <SubHeader />}
      <div className="">
        <h1 className="headerText">{header}</h1>
        <div className="bbs-view">
          <div className="top">
            <strong className="tit">{data.subject}</strong>
            <div className="etc clearfix">
              <span>관리자</span>

              <span>{data.board_date}</span>
            </div>
          </div>

          <div
            className="cont"
            style={{ textAlign: "center" }}
            dangerouslySetInnerHTML={{ __html: dompurify.sanitize(String(data.content)) }}
          ></div>

          {isloggedIn && (
            <div className="bbs-bot1">
              <div className="prev_next clearfix">
                <button className="btn-st2" onClick={updateBoard}>
                  수정
                </button>

                <button className="btn-st2" onClick={deleteBoard}>
                  삭제
                </button>
              </div>

              <div className="r">
                {" "}
                <a href={boardLink} className="btn-st2">
                  목록
                </a>{" "}
              </div>
            </div>
          )}

          {!isloggedIn && (
            <div className="bbs-bot2">
              <div className="center">
                {" "}
                <a href={boardLink} className="btn-st2">
                  목록
                </a>{" "}
              </div>
            </div>
          )}
        </div>
        <div className="bbsbotm_tbl">
          <div className="tbl_basic">
            <table>
              <colgroup>
                <col className="tit"></col>
                <col></col>
                <col className="day hide-m"></col>
              </colgroup>
              <tbody>
                {data.PREV_SN && (
                  <tr>
                    <td>
                      <span className="i-aft i_arr_t1">{i18next.t("prev")}</span>
                      <img className="arrowIcon" src={uparrow} alt="icon"></img>
                    </td>
                    <td className="subject">
                      <span className="i-bat2 ty1 mr20">NOTICE</span>
                      <a
                        href={boardLink + "/view/" + data.PREV_N}
                        className="t_dot"
                      >
                        {data.PREV_SN}
                      </a>
                    </td>
                    <td className="hide-m">2022-04-19</td>
                  </tr>
                )}
                {data.NEXT_SN && (
                  <tr>
                    <td>
                      <span className="i-aft i_arr_b1">{i18next.t("next")}</span>
                      <img
                        className="arrowIcon"
                        src={downarrow}
                        alt="icon"
                      ></img>
                    </td>
                    <td className="subject">
                      <span className="i-bat2 ty1 mr20">NOTICE</span>
                      <a
                        href={boardLink + "/view/" + data.NEXT_N}
                        className="t_dot"
                      >
                        {data.NEXT_SN}
                      </a>
                    </td>
                    <td className="hide-m">2022-03-03</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
